import { Box, Flex, Heading } from "@chakra-ui/react";
import { MovieCardProps } from "../../@types/MovieCard";
import DynamicGrid from "../../components/DynamicGrid";
import { MovieCard_1 } from "../../modules";

function MovieGridWithTitle({
  title,
  movies,
}: {
  title: string;
  movies: MovieCardProps[];
  isLoading?: boolean;
}) {
  return (
    <Box my="2rem">
      <Flex justifyContent="space-between" wrap="wrap">
        <Heading textTransform="uppercase">{title}</Heading>
      </Flex>
      <DynamicGrid baseChildKey="move__card__">
        {movies?.map((movie) => (
          <MovieCard_1 {...movie} />
        ))}
      </DynamicGrid>
    </Box>
  );
}

export default MovieGridWithTitle;
